import { ActionIcon, Tooltip } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCopy } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { trackExpenseShareReminderCopied, trackReminderCopied } from 'src/Services/Mixpanel/events';

import { Props } from './CopyTextButton.types';

const CopyTextButton = ({ text, mixpanelSource, label }: Props) => {
  const { t } = useTranslation();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(text);
    if (mixpanelSource === 'expense_share') {
      trackExpenseShareReminderCopied();
    } else {
      trackReminderCopied({ source: mixpanelSource });
    }
    notifications.show({ message: t('common.copyText.copied', 'Message copié') });
  };

  return (
    <Tooltip label={label}>
      <ActionIcon variant="outline" size="lg" aria-label={label} onClick={handleCopy}>
        <IconCopy size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default CopyTextButton;
